"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const toggleIcon_svg_1 = __importDefault(require("../../../../../assets/icons/toggleIcon.svg"));
const measurementsCalc_1 = require("../../../../../utils/measurementsCalc");
const thresholdColors_1 = require("../../../../../utils/thresholdColors");
const S = __importStar(require("../SessionDetailsModal.style"));
const ModalMobileHeader = ({ toggleVisibility, isVisible, streamShortInfo, thresholds, extremes, isMobile, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { minMeasurementValue, maxMeasurementValue, averageValue } = extremes;
    const noData = (0, measurementsCalc_1.isNoData)(minMeasurementValue, maxMeasurementValue, averageValue);
    return (react_1.default.createElement(S.ModalMobileHeader, null,
        react_1.default.createElement(S.HeaderWrapper, { onClick: toggleVisibility },
            react_1.default.createElement(S.ClickableWrapper, null,
                react_1.default.createElement(S.RotatedIcon, { src: toggleIcon_svg_1.default, alt: t("headerToggle.arrowIcon"), "$rotated": isVisible, onClick: toggleVisibility }),
                react_1.default.createElement(S.SessionName, null, streamShortInfo.title)),
            react_1.default.createElement(S.Wrapper, null, noData ? (react_1.default.createElement(S.NoData, null, t("sessionDetailsModal.noData"))) : (react_1.default.createElement(S.AverageValueContainer, null,
                react_1.default.createElement(S.AverageDot, { "$color": (0, thresholdColors_1.getColorForValue)(thresholds, averageValue) }),
                t("sessionDetailsModal.averageValue"),
                react_1.default.createElement(S.AverageValue, null, averageValue),
                streamShortInfo.unitSymbol)))),
        react_1.default.createElement(S.ContentWrapper, { "$isVisible": isVisible },
            react_1.default.createElement(S.Wrapper, null,
                react_1.default.createElement(S.ProfileName, null, streamShortInfo.profile),
                react_1.default.createElement(S.SensorName, null, streamShortInfo.sensorName)),
            react_1.default.createElement(S.Wrapper, null,
                noData ? (react_1.default.createElement(S.NoData, null, t("sessionDetailsModal.noData"))) : (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(S.MinMaxValueContainer, { "$isMobile": isMobile },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(S.SmallDot, { "$color": (0, thresholdColors_1.getColorForValue)(thresholds, minMeasurementValue) }),
                            t("sessionDetailsModal.minValue"),
                            react_1.default.createElement(S.Value, null, minMeasurementValue)),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(S.SmallDot, { "$color": (0, thresholdColors_1.getColorForValue)(thresholds, maxMeasurementValue) }),
                            t("sessionDetailsModal.maxValue"),
                            react_1.default.createElement(S.Value, null, maxMeasurementValue))))),
                react_1.default.createElement(S.TimeRange, null,
                    streamShortInfo.startTime,
                    " - ",
                    streamShortInfo.endTime)))));
};
exports.default = ModalMobileHeader;
